import type { DocNode } from '@atlaskit/adf-schema/doc';

/**
 * Safely parses a JSON string into a DocNode (ADF document).
 * Returns undefined if the string is null/undefined/empty or not valid JSON.
 */
export const parseAdfString = (adfString: string | null | undefined): DocNode | undefined => {
	if (!adfString) return undefined;
	try {
		return JSON.parse(adfString) as DocNode;
	} catch {
		return undefined;
	}
};
